var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5605 0.294082C11.1781 -0.0980273 15.8219 -0.0980276 20.4395 0.294082L22.6642 0.482996C24.1452 0.608757 25.4136 1.47168 26.0709 2.70602C26.1549 2.86393 26.0919 3.05512 25.937 3.1488L16.7067 8.73057C14.727 9.9277 12.2308 9.95281 10.2264 8.79577L0.934323 3.43212C0.7842 3.34547 0.715292 3.16709 0.782947 3.01009C1.3842 1.61489 2.73596 0.618847 4.33579 0.482996L6.5605 0.294082Z",
    fill: "#EB6424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.775386 5.84756C0.545637 5.71494 0.252486 5.85765 0.225705 6.11702C-0.148071 9.73701 -0.0576069 13.3913 0.497098 16.9947C0.789528 18.8943 2.37665 20.3506 4.33579 20.517L6.5605 20.7059C11.1781 21.098 15.8219 21.098 20.4395 20.7059L22.6642 20.517C24.6233 20.3506 26.2105 18.8943 26.5029 16.9947C27.0738 13.2863 27.1529 9.52399 26.7404 5.80064C26.7115 5.53944 26.4134 5.39935 26.1847 5.53764L17.8697 10.5659C15.1914 12.1855 11.8142 12.2195 9.10224 10.6541L0.775386 5.84756Z",
    fill: "#EB6424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingIcon);
export default __webpack_public_path__ + "static/media/training-icon.9e1dfefa0e4ad32c52b7bf9775eba256.svg";
export { ForwardRef as ReactComponent };